export default {"src":"/_next/static/media/ra-aircraft-fill.2285b658.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};